import { useGetEnrollmentMultiFundingData } from '@egw/api'
import { useAuth } from '@egw/auth'
import { ActionTile } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { sendEvent } from '@egw/events'
import { useTranslation } from '@egw/i18n'
import { EnrollmentMultiLayout } from '@egw/layouts'
import { useEffect, type FC } from 'react'
import { useNavigate } from 'react-router'
import { PageHeader } from '../../../components'
import { ALL_ENROLLMENT_ROUTES } from '../../../constants'

export const FundAccountPage: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { refreshToken } = useAuth()
  const navigate = useNavigate()

  const { data, isLoading, error } = useGetEnrollmentMultiFundingData()

  const transferFundsInitiated =
    data?.__typename === 'SubmitEnrollmentSuccess' ? data.enrollmentData?.transferFundsInitiated : false

  const fundLaterHandler = (): void => {
    sendEvent('bankmulti_enroll_funding_skip')
    void navigate(`${WEALTH_ROUTES.ENROLLMENT.path}/${ALL_ENROLLMENT_ROUTES.MULTI.ROUTES.CREATE_PASSKEY.path}`)
  }

  // Refresh token on mount as user should theoretically be authenticated
  // This will ensure that if the user skips funding, they will reach Overview page
  useEffect(() => {
    void refreshToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fundingOptionHandler = (path: string) => {
    void navigate(path)
  }

  return (
    <EnrollmentMultiLayout title={t('multi.funding.page_title')}>
      <PageHeader title={t('multi.funding.title')} className="mb-md" />
      <p className="typo-primary-base text-text-meta mb-2xl">{t('multi.funding.description')}</p>
      <div className="flex flex-col gap-sm w-full">
        <ActionTile
          testId="enrollment_multi_account_transfer_link"
          title={t('multi.funding.account_transfer_title')}
          description={t('multi.funding.account_transfer_description')}
          onClick={() => {
            fundingOptionHandler(
              `${WEALTH_ROUTES.ENROLLMENT.path}/${ALL_ENROLLMENT_ROUTES.MULTI.ROUTES.ACCOUNT_TRANSFER.path}`,
            )
          }}
        />
        <ActionTile
          testId="enrollment_multi_wire_transfer_link"
          title={t('multi.funding.wire_transfer_title')}
          description={t('multi.funding.wire_transfer_description')}
          onClick={() => {
            fundingOptionHandler(
              `${WEALTH_ROUTES.ENROLLMENT.path}/${ALL_ENROLLMENT_ROUTES.MULTI.ROUTES.WIRE_TRANSFER.path}`,
            )
          }}
        />
        <ActionTile
          testId="enrollment_multi_bank_transfer_link"
          title={t('multi.funding.bank_transfer_title')}
          description={t('multi.funding.bank_transfer_description')}
          disabled={Boolean(transferFundsInitiated)}
          onClick={() => {
            fundingOptionHandler(
              `${WEALTH_ROUTES.ENROLLMENT.path}/${ALL_ENROLLMENT_ROUTES.MULTI.ROUTES.BANK_TRANSFER.path}`,
            )
          }}
        />
      </div>
      <button
        type="button"
        onClick={() => void fundLaterHandler()}
        className="text-text-action typo-primary-base-semibold mt-2xl"
      >
        {t('multi.funding.fund_later')}
      </button>
    </EnrollmentMultiLayout>
  )
}
